



















import Vue from 'vue';
import VueApexCharts from 'vue-apexcharts';
import { ApexOptions } from 'apexcharts';

export default Vue.extend({
  components: {
    apexchart: VueApexCharts,
  },
  props: ['propertyName'],
  computed: {
    class_counts(): { keys: string[]; values: number[] } {
      const analysisResult =
        this.$store.getters.labelAnalysisResult[this.propertyName].class_counts;
      let arr = Object.keys(analysisResult).map((key) => {
        return {
          key: key,
          value: analysisResult[key],
        };
      });
      arr = arr.sort((a, b) => b.value - a.value);

      const rtClassCounts = {
        keys: [] as string[],
        values: [] as number[],
      };
      arr.map((record) => {
        rtClassCounts.keys.push(record.key);
        rtClassCounts.values.push(record.value);
      });
      return rtClassCounts;
    },
    histSeries(): [{ name: string; data: Array<number> }] {
      return [
        {
          name: 'Count',
          data: this.class_counts.values,
        },
      ];
    },
    histChartOptions(): ApexOptions {
      return {
        chart: {
          stacked: true,
          stackType: 'normal',
          toolbar: {
            show: true,
          },
          width: '100%',
        },
        colors: ['#5BD99C'],
        xaxis: {
          position: 'bottom',
          labels: {
            show: true,
          },
          categories: this.class_counts.keys,
        },
        yaxis: {
          labels: {
            show: true,
          },
        },
        fill: {
          opacity: 1,
        },
        legend: {
          position: 'right',
          fontSize: '12px',
          show: true,
          inverseOrder: true,
        },
        dataLabels: {
          enabled: false,
          offsetY: -20,
          style: {
            colors: ['#192A3E'],
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 10,
            dataLabels: {
              position: 'top',
            },
          },
        },
      };
    },
  },
});
